import { parseDateTime } from '@internationalized/date';
import { WidgetProps } from '@rjsf/utils';

import DatePicker from 'design-system/components/DatePicker';

export function DateWidget({ id, value, disabled, onChange, schema, rawErrors = [] }: WidgetProps) {
  return (
    <div
      css={{
        width: '100%',
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <DatePicker
        value={typeof value === 'string' ? parseDateTime(value) : null}
        onChange={(nextDate) => {
          onChange(nextDate?.toString() ?? null);
        }}
        isDisabled={disabled}
        granularity='second'
        aria-label={schema.title || id}
        errorMessage={rawErrors.length > 0 ? rawErrors[0] : undefined}
      />
    </div>
  );
}
export default DateWidget;
